<template>
    <div class="main-div">
        <div class="header-div">
            <div class="title-div">
                <div class="icon-text-header">
                    <div class="icon-div">
                        <svg xmlns="http://www.w3.org/2000/svg" width="380" height="380" viewBox="0 0 480 480" fill="none" class="pattern" opacity="0.4" >
                            <defs>
                                <clipPath id="clip-circle">
                                    <rect x="190" y="190" width="240" height="240" />
                                </clipPath>
                            </defs>
                            <g clip-path="url(#clip-circle)">
                                <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                            <path
                                d="M18.25 0.25H1.75C1.35218 0.25 0.970644 0.408035 0.68934 0.68934C0.408035 0.970644 0.25 1.35218 0.25 1.75V14.5C0.25 14.8978 0.408035 15.2794 0.68934 15.5607C0.970644 15.842 1.35218 16 1.75 16H3.25V17.5C3.25 17.6989 3.32902 17.8897 3.46967 18.0303C3.61032 18.171 3.80109 18.25 4 18.25C4.19891 18.25 4.38968 18.171 4.53033 18.0303C4.67098 17.8897 4.75 17.6989 4.75 17.5V16H15.25V17.5C15.25 17.6989 15.329 17.8897 15.4697 18.0303C15.6103 18.171 15.8011 18.25 16 18.25C16.1989 18.25 16.3897 18.171 16.5303 18.0303C16.671 17.8897 16.75 17.6989 16.75 17.5V16H18.25C18.6478 16 19.0294 15.842 19.3107 15.5607C19.592 15.2794 19.75 14.8978 19.75 14.5V1.75C19.75 1.35218 19.592 0.970644 19.3107 0.68934C19.0294 0.408035 18.6478 0.25 18.25 0.25ZM18.25 14.5H1.75V1.75H18.25V7.75H16.6863C16.4982 6.63745 15.899 5.63615 15.0075 4.94452C14.116 4.25289 12.9972 3.9214 11.8729 4.01576C10.7485 4.11012 9.70059 4.62343 8.93683 5.45397C8.17307 6.28451 7.74919 7.37167 7.74919 8.5C7.74919 9.62833 8.17307 10.7155 8.93683 11.546C9.70059 12.3766 10.7485 12.8899 11.8729 12.9842C12.9972 13.0786 14.116 12.7471 15.0075 12.0555C15.899 11.3639 16.4982 10.3625 16.6863 9.25H18.25V14.5ZM13.5475 7.75C13.3824 7.46404 13.1276 7.24054 12.8225 7.11418C12.5174 6.98782 12.1792 6.96565 11.8602 7.05111C11.5413 7.13657 11.2594 7.32489 11.0584 7.58686C10.8574 7.84882 10.7485 8.1698 10.7485 8.5C10.7485 8.8302 10.8574 9.15118 11.0584 9.41314C11.2594 9.67511 11.5413 9.86343 11.8602 9.94889C12.1792 10.0344 12.5174 10.0122 12.8225 9.88582C13.1276 9.75946 13.3824 9.53596 13.5475 9.25H15.1562C14.9737 9.95699 14.5396 10.5731 13.9352 10.983C13.3309 11.3928 12.5979 11.5681 11.8735 11.4761C11.1491 11.3841 10.4832 11.0311 10.0005 10.4832C9.51782 9.93529 9.25151 9.23018 9.25151 8.5C9.25151 7.76982 9.51782 7.0647 10.0005 6.51683C10.4832 5.96895 11.1491 5.61592 11.8735 5.52391C12.5979 5.43191 13.3309 5.60724 13.9352 6.01705C14.5396 6.42686 14.9737 7.04301 15.1562 7.75H13.5475Z"
                                fill="#181D27"
                            />
                        </svg>
                    </div>
                    <div>
                        <div class="title-section">
                            <p>Add Relative</p>
                            <div class="close-icon" @click="closeDialog">
                                <!-- <XMarkIcon class="h-[24px] w-[24px]" /> -->
                            </div>
                        </div>
                        <p class="sub-title">Enter the relative you'd like to add to your Identity Vault</p>
                    </div>
                </div>
                <div class="title-wrapper">                    
                    <div class="divider"></div>
                    <div class="flex sm:flex-row flex-col items-start gap-2.5 w-full">
                        <div class="name-div">
                            <span>First Name</span>
                            <prime-input-text v-model="firstName" class="w-full" type="text" placeholder="John" />
                        </div>
                        <div class="name-div">
                            <span>Last Name</span>
                            <prime-input-text v-model="lastName" class="w-full" type="text" placeholder="Doe" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-relative-footer">
            <div class="footer-actions">
                <prime-button @click="closeDialog" variant="secondary" label="Cancel" class="p-btn-root_secondary" />

                <prime-button label="Add Relative" variant="primary" :disabled="firstName === '' || lastName === ''" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ModalNames } from '~/types/modals';

const firstName = ref('');
const lastName = ref('');

    const dialogRef = getDialogRef(ModalNames.ADD_RELATIVE);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-xl sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
.title-div {
    @apply flex flex-col p-6 pb-0 items-start gap-1 self-stretch w-full;
}
.icon-text-header{
    @apply flex flex-row items-start gap-4 items-start w-full ;
}
.icon-div {
    @apply relative flex w-12 h-12 p-3 justify-center items-center rounded-full bg-gray-100;
}
.title-wrapper {
    @apply flex flex-col items-start gap-1 sm:flex-1 sm:w-auto w-full sm:pl-16;
}
.title-section {
    @apply self-stretch flex flex-row justify-between relative;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.close-icon {
    @apply flex justify-center items-center rounded-lg text-gray-400 cursor-pointer;
}
.sub-title {
    @apply text-zinc-600 font-inter text-sm font-normal leading-5;
}
.pattern {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
}
.divider {
    @apply h-px bg-zinc-300 mt-4 mb-3.5 w-full;
}
.add-relative-footer {
    @apply flex flex-col justify-center items-end self-stretch pt-8;

    .footer-actions {
        @apply flex justify-end items-center gap-3 flex-1 px-6 pb-6  ;
    }
}
.name-div {
    @apply flex flex-col items-start gap-1.5 self-stretch;

    span {
        @apply font-inter text-gray-700 text-sm font-medium leading-5;
    }
}
</style>
